// extracted by mini-css-extract-plugin
export default {"container":"error-module__container--4c15"};